<div>
  <mic-breadcrumb>
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('setupText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link
      link="/home{{ tabRouteLink }}"
      label="{{ translationService.translate('usersAndGroupsText') }}"
    ></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h2 class="page-title page-header-spacing" id="user-setup-heading">{{ translationService.translate('usersAndGroupsText') }}</h2>

  <mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    mat-stretch-tabs="false"
    style="border-bottom: 0 !important"
    (selectedTabChange)="onTabChange($event)"
  >
    <!-- Users Tab -->
    @if (hasRolePermission(ROLES.view_user) || hasRolePermission(ROLES.edit_user)) {
    <mat-tab label="{{ translationService.translate('usersText') }}">
      <ng-template matTabContent>
        <a [routerLink]="['']"></a>
        <a [routerLink]="['user', 'userId']"></a>
        <a [routerLink]="['user', 'userId', 'select-customer']"></a>
      </ng-template>
    </mat-tab>
    }

    <!-- Groups Tab -->
    @if (hasRolePermission(ROLES.view_user_group)) {
    <mat-tab label="{{ translationService.translate('groupsText') }}">
      <ng-template matTabContent>
        <a [routerLink]="['user-group']"></a>
        <a [routerLink]="['user-group', 'group-name', 'groupId']"></a>
        <a [routerLink]="['user-group', 'create']"></a>
      </ng-template>
    </mat-tab>
    }
  </mat-tab-group>

  <router-outlet></router-outlet>
</div>
